import { useMemo } from "react";
import { useAdminToolCalls } from "./useAdminToolCalls";
import { rangeToWindowHours, type InstanceRange } from "../lib/instanceDetailRange";

// Per-instance tool logs: the full keyset-paged Tool Logs query, scoped to one
// tenant and the dashboard's selected time window. A thin wrapper over
// useAdminToolCalls so the panel and the admin tab share one fetch + pager path.
export const useInstanceToolLogs = (tenantId: string, range: InstanceRange) => {
  const startedAfter = useMemo(
    () => Date.now() - rangeToWindowHours(range) * 3_600_000,
    [tenantId, range],
  );
  return useAdminToolCalls({ tenantId, startedAfter });
};
